module.exports = __WEBPACK_EXTERNAL_MODULE_https_cdn_web_vanguard_com_c11n_web_b6_switch_js_7025c4df__;